import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const coralogix = defineConnector({
  identifier: "coralogix",
  name: "Coralogix",
  tagLine: "Observability and log analytics",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: ({ domain }) =>
    domainToRegex(`api.${domain || "eu1.coralogix.com"}`),
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.apiKey,
        scheme: "Bearer",
      },
    ]),
  steps: [
    {
      title: "Select your region and get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In your Coralogix dashboard, go to **Settings > Users and Teams > API Keys** and create a new key with the permissions you need.",
        },
        {
          kind: "select",
          label: "Region",
          required: true,
          defaultValue: "eu1.coralogix.com",
          target: { kind: "configuration", field: "domain" },
          options: [
            {
              value: "eu1.coralogix.com",
              label: "EU1 – Ireland (eu1.coralogix.com)",
            },
            {
              value: "eu2.coralogix.com",
              label: "EU2 – Stockholm (eu2.coralogix.com)",
            },
            {
              value: "us1.coralogix.com",
              label: "US1 – Ohio (us1.coralogix.com)",
            },
            {
              value: "us2.coralogix.com",
              label: "US2 – Oregon (us2.coralogix.com)",
            },
            {
              value: "us3.coralogix.com",
              label: "US3 – Iowa (us3.coralogix.com)",
            },
            {
              value: "ap1.coralogix.com",
              label: "AP1 – Mumbai (ap1.coralogix.com)",
            },
            {
              value: "ap2.coralogix.com",
              label: "AP2 – Singapore (ap2.coralogix.com)",
            },
            {
              value: "ap3.coralogix.com",
              label: "AP3 – Jakarta (ap3.coralogix.com)",
            },
            {
              value: "gov1.coralogixgov.us",
              label: "GOV1 – AWS GovCloud (gov1.coralogixgov.us)",
            },
          ],
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => ({
      url: `https://api.${domain}/api/v1/dataprime/query`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: "source logs | limit 1" }),
      expectedBodyContains: '"queryId"',
    }),
  },
  publicEnvVars: ({ domain }) => ({ CORALOGIX_DOMAIN: domain || "" }),
});
